import { render, staticRenderFns } from "./BookView.vue?vue&type=template&id=1d46c930&scoped=true&"
import script from "./BookView.vue?vue&type=script&lang=js&"
export * from "./BookView.vue?vue&type=script&lang=js&"
import style0 from "./BookView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BookView.vue?vue&type=style&index=1&id=1d46c930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d46c930",
  null
  
)

export default component.exports